/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tyc_Definitions_Tenant_Admin_DescInputs */

const es_tyc_definitions_tenant_admin_desc = /** @type {(inputs: Tyc_Definitions_Tenant_Admin_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Usuario con privilegios para gestionar configuraciones a nivel de inquilino.`)
};

const en_tyc_definitions_tenant_admin_desc = /** @type {(inputs: Tyc_Definitions_Tenant_Admin_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A User with privileges to manage tenant-level configurations.`)
};

/**
* | output |
* | --- |
* | "A User with privileges to manage tenant-level configurations." |
*
* @param {Tyc_Definitions_Tenant_Admin_DescInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const tyc_definitions_tenant_admin_desc = /** @type {((inputs?: Tyc_Definitions_Tenant_Admin_DescInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tyc_Definitions_Tenant_Admin_DescInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_tyc_definitions_tenant_admin_desc(inputs)
	return en_tyc_definitions_tenant_admin_desc(inputs)
});
export { tyc_definitions_tenant_admin_desc as "tyc.definitions.tenant_admin_desc" }